module.exports = __webpack_public_path__ + "static/media/img_me_two.84c95cbc.jpg";